<template>
    <modal
        :show="show"
        modal-classes="modal-dialog-centered"
        @update:show="onShowChange"
        @close="onModalClose"
    >
        <div class="ws-drawer">
            <header class="ws-drawer__head">
                <span class="ws-drawer__icon" aria-hidden="true">
                    <i class="fa" :class="icon"></i>
                </span>
                <div class="ws-drawer__heading">
                    <span class="ws-drawer__eyebrow">{{ eyebrow }}</span>
                    <h2>{{ title }}</h2>
                    <p v-if="subtitle">{{ subtitle }}</p>
                </div>
                <button
                    type="button"
                    class="ws-drawer__close"
                    aria-label="Close"
                    :disabled="saving"
                    @click="requestClose"
                >
                    <i class="fa fa-times" aria-hidden="true"></i>
                </button>
            </header>

            <form :id="formId" class="ws-form" novalidate @submit.prevent="$emit('submit')">
                <slot></slot>
            </form>
        </div>

        <template slot="footer">
            <div class="ws-drawer__actions">
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    :disabled="saving"
                    @click="requestClose"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    class="btn ws-save-button"
                    :form="formId"
                    :disabled="saving || submitDisabled"
                >
                    <i
                        class="fa"
                        :class="saving ? 'fa-spinner fa-spin' : 'fa-check'"
                        aria-hidden="true"
                    ></i>
                    <span>{{ saving ? "Saving…" : submitLabel }}</span>
                </button>
            </div>
        </template>
    </modal>
</template>

<script>
import modal from "@/components/Modal";

export default {
    name: "SetupDrawer",
    components: {
        modal
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: "fa-list-ul"
        },
        eyebrow: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        subtitle: {
            type: String,
            default: ""
        },
        saving: {
            type: Boolean,
            default: false
        },
        submitLabel: {
            type: String,
            default: "Save"
        },
        submitDisabled: {
            type: Boolean,
            default: false
        },
        formId: {
            type: String,
            default: "ws-setup-form"
        }
    },
    methods: {
        requestClose() {
            if (this.saving) return;
            this.$emit("update:show", false);
            this.$emit("close");
        },
        onShowChange(value) {
            if (this.saving && value === false) return;
            this.$emit("update:show", value);
        },
        onModalClose() {
            if (this.saving) return;
            this.$emit("close");
        },
        handleKeydown(event) {
            if (event.key !== "Escape") return;
            if (!this.show || this.saving) return;
            this.requestClose();
        }
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeydown);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeydown);
    }
};
</script>
